import { useGSAP } from '@gsap/react'
import { gsap } from 'gsap'
import { useRef } from 'react'

import useMediaQuery from './hooks/useMediaQuery'

export const FadeUpInView = ({
  children,
  className,
  delay = 0,
  stagger = 0.25,
  start = 'top bottom',
  end = 'bottom center',
}: {
  children: React.ReactNode
  className?: string
  delay?: number
  stagger?: number
  start?: string
  end?: string
}) => {
  const ref = useRef<HTMLSpanElement>(null)
  const isMobile = useMediaQuery('(max-width: 1024px)')

  useGSAP(() => {
    const element = ref.current
    if (element) {
      gsap.fromTo(
        element.children,
        {
          y: 20,
          opacity: 0,
        },
        {
          y: 0,
          opacity: 1,
          duration: 1.5,
          stagger: stagger,
          delay: delay,
          ease: 'expo.out',
          scrollTrigger: {
            trigger: element,
            start,
            end,
            scrub: !isMobile,
          },
        },
      )
    }
  }, [children, delay, stagger])

  if (isMobile) {
    return <>{children}</>
  }

  return (
    <span
      ref={ref}
      className={`inline-block relative will-change-transform transition duration-1500 ease-cubic-out ${className}`}
    >
      {children}
    </span>
  )
}
